import { NavLink, Outlet, useParams, Link, Navigate } from 'react-router-dom';
import { StoreProvider, useStore } from './StoreContext';
import { useApp } from './AppContext';
import { ChatProvider, useChat } from './ChatContext';
import { ChatPopup } from '../components/ChatPopup';

const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function StoreLayout() {
  const { slug = '' } = useParams();
  if (!SLUG_RE.test(slug)) return <Navigate to="/" replace />;
  return (
    <StoreProvider slug={slug}>
      <ChatProvider>
        <StoreFrame />
      </ChatProvider>
    </StoreProvider>
  );
}

function StoreFrame() {
  const { slug, store, loading, error, cartCount } = useStore();
  const { me, signedIn, isGuest, isOwner, signOut } = useApp();
  const chat = useChat();

  if (loading && !store) return <div className="page center muted">Loading…</div>;
  if (error || !store) {
    return (
      <div className="page center">
        <h1>Store not found</h1>
        <p className="muted">{error || 'This store is not available.'}</p>
        <Link className="btn" to="/">All stores</Link>
      </div>
    );
  }

  const base = `/${slug}`;
  const ownerHere = isOwner && me?.businessSlug === slug;

  return (
    <div className="store">
      <header className="store-header">
        <Link to={base} className="brand">
          {store.branding.logoUrl
            ? <img className="brand-logo" src={store.branding.logoUrl} alt={store.displayName} />
            : <span className="brand-mark" aria-hidden>{store.displayName.slice(0, 1)}</span>}
          <span className="brand-name">{store.displayName}</span>
        </Link>
        <div className="store-account">
          {signedIn
            ? <>
                {ownerHere && <Link className="btn btn-sm" to={`${base}/admin`}>Admin</Link>}
                <button className="btn btn-sm btn-ghost" onClick={signOut}>Sign out</button>
              </>
            : <Link className="btn btn-sm" to={`${base}/login`} title={isGuest ? 'You are ordering as a guest' : undefined}>Sign in</Link>}
        </div>
      </header>
      <nav className="store-nav" aria-label="Store">
        <NavLink end to={base}>Menu</NavLink>
        <NavLink to={`${base}/hours`}>Hours</NavLink>
        <NavLink to={`${base}/about`}>About</NavLink>
        <button className={`nav-btn ${chat.open ? 'active' : ''}`} onClick={() => chat.setOpen(!chat.open)}>Chat</button>
        <NavLink to={`${base}/orders`}>Orders</NavLink>
        <NavLink to={`${base}/cart`} className="nav-cart">
          Cart{cartCount > 0 && <span className="badge">{cartCount}</span>}
        </NavLink>
      </nav>
      <main className="store-main">
        <Outlet />
      </main>
      <footer className="store-footer muted">
        <Link to="/">All stores</Link>
      </footer>
      <ChatPopup />
    </div>
  );
}
